export default function uninitializeVue(app, initialize) {
  const uninitialize = () => {
    app.$destroy();
    document.removeEventListener("turbo:before-visit", uninitialize);
    document.removeEventListener("turbo:load", initialize);
  };
  document.addEventListener("turbo:turbo:before-visit", uninitialize);
}
